<code
  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-5 d-flex gap-4 mb-2 mx-0"
>
  <pre
    class="m-0"
    [innerHTML]="
      value()
        | prettyJson: [{ showNumberLine: showNumberLine(), padding: padding() }]
    "
  ></pre>
</code>
